var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_341_14340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_341_14340)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0H13.3333V1.33333H28V0ZM28 2.66667H13.3333V4H28V2.66667ZM13.3333 5.33333H28V6.66667H13.3333V5.33333ZM28 8H13.3333V9.33333H28V8ZM0 10.6667H28V12H0V10.6667ZM28 13.3333H0V14.6667H28V13.3333ZM0 16H28V17.3333H0V16ZM28 18.6667H0V20H28V18.6667Z",
    fill: "#E1244A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10.6667,
    fill: "#0C3F8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66666 9.33333C7.61177 9.33333 8.48032 9.00556 9.16484 8.45748C8.80223 8.59273 8.40974 8.66667 7.99999 8.66667C6.15904 8.66667 4.66666 7.17428 4.66666 5.33333C4.66666 3.49238 6.15904 2 7.99999 2C8.40974 2 8.80223 2.07393 9.16484 2.20919C8.48032 1.66111 7.61177 1.33333 6.66666 1.33333C4.45752 1.33333 2.66666 3.12419 2.66666 5.33333C2.66666 7.54247 4.45752 9.33333 6.66666 9.33333ZM9.50963 7.73592L10.6667 6.42667L11.8237 7.73592L11.5215 6.01502L13.2665 5.92672L11.7326 5.09004L12.7515 3.67069L11.141 4.34827L10.6667 2.66667L10.1923 4.34827L8.58177 3.67069L9.60074 5.09004L8.06685 5.92672L9.81185 6.01502L9.50963 7.73592Z",
    fill: "#FFD34F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/MY.51a6b5c1.svg";
export { ForwardRef as ReactComponent };